import {
    GET_USERS_REQUEST,
    GET_USERS_FAILURE,
    GET_USERS_SUCCESS,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    CHANGE_USER_STATUS_REQUEST,
    CHANGE_USER_STATUS_SUCCESS,
    CHANGE_USER_STATUS_FAILURE,
    ADD_USER_REQUEST,
    ADD_USER_FAILURE,
    ADD_USER_SUCCESS,
    EDIT_USER_REQUEST,
    EDIT_USER_FAILURE,
    EDIT_USER_SUCCESS,
    GET_ALL_USERS_SUCCESS,
    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_FAILURE,
    GET_DENTIST_INFO_REQUEST,
    GET_DENTIST_INFO_SUCCESS,
    GET_DENTIST_INFO_FAILURE,
    GENERATE_RESET_PASSWORD_LINK_REQUEST,
    GENERATE_RESET_PASSWORD_LINK_SUCCESS,
    GENERATE_RESET_PASSWORD_LINK_FAILURE
} from './constants';

export function getUsers(page, filterOptions, sortingOptions) {
    return {
        type: GET_USERS_REQUEST,
        data: { page, filterOptions, sortingOptions }
    }
}

export function getUsersSuccess(response) {
    return {
        type: GET_USERS_SUCCESS,
        data: response
    }
}

export function getUsersFailure() {
    return {
        type: GET_USERS_FAILURE,
        data: {}
    }
}

export function getAllUsers() {
    return {
        type: GET_ALL_USERS_REQUEST,
        data: {}
    }
}

export function getAllUsersSuccess(response) {
    return {
        type: GET_ALL_USERS_SUCCESS,
        data: response
    }
}

export function getAllUsersFailure() {
    return {
        type: GET_ALL_USERS_FAILURE,
        data: {}
    }
}

export function deleteUser(userId, page, filterOptions, sortingOptions) {
    return {
        type: DELETE_USER_REQUEST,
        data: { userId, page, filterOptions, sortingOptions }
    }
}

export function deleteUserSuccess(response) {
    return {
        type: DELETE_USER_SUCCESS,
        data: response
    }
}

export function deleteUserFailure() {
    return {
        type: DELETE_USER_FAILURE,
        data: {}
    }
}

export function changeUserStatus(userId, status, page, filterOptions, sortingOptions) {
    return {
        type: CHANGE_USER_STATUS_REQUEST,
        data: {userId: userId, status: status, page, filterOptions, sortingOptions}
    }
}

export function changeUserStatusSuccess(response) {
    return {
        type: CHANGE_USER_STATUS_SUCCESS,
        data: response
    }
}

export function changeUserStatusFailure() {
    return {
        type: CHANGE_USER_STATUS_FAILURE,
        data: {}
    }
}

export function addUser (data) {
    return {
        type: ADD_USER_REQUEST,
        data
    }
}

export function addUserSuccessAction (data) {
    return {
        type: ADD_USER_SUCCESS,
        data
    }
}

export function addUserFailureAction (data) {
    return {
        type: ADD_USER_FAILURE,
        data
    }
}

export function editUser (data) {
    return {
        type: EDIT_USER_REQUEST,
        data
    }
}

export function editUserSuccessAction (data) {
    return {
        type: EDIT_USER_SUCCESS,
        data
    }
}

export function editUserFailureAction (data) {
    return {
        type: EDIT_USER_FAILURE,
        data
    }
}

export function getDentistInfo (data) {
    return {
        type: GET_DENTIST_INFO_REQUEST,
        data
    }
}

export function getDentistInfoSuccessAction (data) {
    return {
        type: GET_DENTIST_INFO_SUCCESS,
        data
    }
}

export function getDentistInfoFailureAction (data) {
    return {
        type: GET_DENTIST_INFO_FAILURE,
        data
    }
}

export function generateResetPasswordLink (email) {
    return {
        type: GENERATE_RESET_PASSWORD_LINK_REQUEST,
        data: { email }
    }
}
export function generateResetPasswordLinkSuccess (data) {
    return {
        type: GENERATE_RESET_PASSWORD_LINK_SUCCESS,
        data
    }
}
export function generateResetPasswordLinkFailure (data) {
    return {
        type: GENERATE_RESET_PASSWORD_LINK_FAILURE,
        data
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/actions.js